//@vendor
const isString = require('lodash/lang/isString');

// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');

// @ commons
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder.js');

const setAmount = (amount) => ({
    type: actionTypes.MODIFY_CHORE_SET_AMOUNT,
    payload: {
        amount
    }
});

const setChoreType = (choreType) => ({
    type: actionTypes.MODIFY_CHORE_SET_CHORE_TYPE,
    payload: {
        choreType
    }
});

const validityDateChanged = (selectedEndDate) => ({
    type: actionTypes.MODIFY_CHORE_VALIDITY_DATE_CHANGED,
    payload: {
        selectedEndDate
    }
});

const conceptChanged = (concept) => ({
    type: actionTypes.MODIFY_CHORE_CONCEPT_CHANGED,
    payload: {
        concept
    }
});

const setVisibleStep = (step)  => ({
    type: actionTypes.MODIFY_CHORE_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const validateStep = (step) => ({
    type: actionTypes.MODIFY_CHORE_VALIDATE_STEP,
    payload: {
        step
    }
});

const reset = () => ({
    type: actionTypes.MODIFY_CHORE_RESET
});

const setWillCancel = (willCancel) => ({
    type: actionTypes.MODIFY_CHORE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const requestOpenYoungChoreListDetails = () => ({
    type: actionTypes.MODIFY_CHORE_DETAILS_REQUEST
});

const requestOpenYoungChoreListSuccess = (choreList) => ({
    type: actionTypes.MODIFY_CHORE_DETAILS_SUCCESS,
    payload: {
        choreList
    }
});

const requestOpenYoungChoreListFailure = (getChoreDetailsError) => ({
    type: actionTypes.MODIFY_CHORE_DETAILS_ERROR,
    payload: {
        getChoreDetailsError
    }
});

const requestOpenYoungModifyChore = () => ({
    type: actionTypes.MODIFY_CHORE_CONFIRM_REQUEST
});

const requestOpenYoungModifyChoreSuccess = (cardDetails) => ({
    type: actionTypes.MODIFY_CHORE_CONFIRM_SUCCESS,
    payload: {
        cardDetails
    }
});

const requestOpenYoungModifyChoreFailure = (error) => ({
    type: actionTypes.MODIFY_CHORE_CONFIRM_ERROR,
    payload: {
        error
    }
});

const setTotalAvailableBalance = (totalAvailableBalance) => ({
    type: actionTypes.MODIFY_CHORE_AVAILABLE_BALANCE,
    payload: {
        totalAvailableBalance
    }
});

const setRepetitionType = (selectedRepetitionType) => ({
    type: actionTypes.MODIFY_CHORE_SET_REPETITION_TYPE,
    payload: {
        selectedRepetitionType
    }
});
const setRepetitionOptionsList = (repetitionOptionList) => ({
    type: actionTypes.MODIFY_CHORE_SET_REPETITION_OPTION_LIST,
    payload: {
        repetitionOptionList
    }
});

const getChoresList = () => (dispatch) => {
    dispatch(requestOpenYoungChoreListDetails());
    return APIGet({
        dispatch,
        url: apiURLBuilder.getURL('openYoungChoreTypesList')
    })
    .then(response => dispatch(requestOpenYoungChoreListSuccess(response)))
    .catch( response => {
        if (!!response.error) {
            dispatch(requestOpenYoungChoreListFailure(response.error));
        } else {
            throw response;
        }
    })
}

const postChoreConfirm = (immCard, step, choreAssignmentId) => (dispatch) => {
    const selectedType = step.get('selectedRepetitionType');
    const repeatTask = isString(selectedType) ? 0 : selectedType ;
    const panNumber = immCard.getIn(['interventionList',0,'pan']);

    const requestData = {
    query: {
            childDetail: {
                contractNumber: immCard.getIn(['contract','number']), 
                pan: panNumber && panNumber.substr(-4), 
                productCode: immCard.getIn(['contract','product'])
            },
            choreAssignmentComment: step.get('concept'),
            endDate: step.get('selectedEndDate').format(DATE_FORMAT_API),
            repeatTask: repeatTask, 
            reward: step.get('amount')
        }
    }

    dispatch(requestOpenYoungModifyChore());
    return APIPost({
        dispatch,
        url: apiURLBuilder.getURL('openYoungModifyChoreConfirm', {choreAssignmentId}),
        params: requestData
    })
    .then(response => dispatch(requestOpenYoungModifyChoreSuccess(response)))
    .catch( response => {
        if (!!response.error) {
            dispatch(requestOpenYoungModifyChoreFailure(response.error))
        } else {
            throw response;
        }
    })
}

module.exports = {
    conceptChanged,
    getChoresList,
    postChoreConfirm,
    reset,
    setAmount,
    setChoreType,
    setTotalAvailableBalance,
    setVisibleStep,
    setWillCancel,
    setRepetitionType,
    setRepetitionOptionsList,
    validateStep,
    validityDateChanged
}
